export default __webpack_public_path__ + "static/media/beansImage.ec341c2e.png";